import React, { useEffect, useRef, useState } from "react";
import { Button, Card, CardBody, Col, Container, Form, Label, Modal, ModalBody, ModalFooter, ModalHeader, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import classnames from "classnames";
import { useFormik } from "formik";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { AddressModel } from "models/City";
import { toast } from "react-toastify";
toast.configure();
import "react-toastify/dist/ReactToastify.css";
import { Radio, RadioChangeEvent, Select } from "antd";
import { SelectValue } from "antd/lib/select";
import { personalPlaceOrderSchema, placeOrderSchema } from "schemas/placeOrderSchema";
import { OrderService } from "services/OrderService";
import { Order } from "models/Order";
import { DeliverOption } from "enum/DeliveryOption";
import { OrderResponse } from "models/orderResponse";
import "moment/locale/en-gb";
import AddressBookModal from "modals/AddressBookModal";
import { AddressBook } from "models/AddressBook";
import { environment } from "environment/environment";
import { AuthData, useAuth } from "context/AuthProvider";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import "moment-timezone";
import { PaymentOption, PaymentType } from "enum/PaymentOption";
import { InputValueType } from "components/Common/auto-complete/google-places-autocomplete";
import CustomGooglePlacesAutocompleteOrders from "components/Common/auto-complete-order";
import { AddressType } from "enum/AddressType";
import Swal from "sweetalert2";
import { NotificationData, useNotification } from "context/NotificationProvider";
import { NotificationService } from "services/NotificationService";
import { AdminService } from "services/AdminService";
import { useDispachCount } from "context/OrderCountProvider";
import DeliveryVerificationModal from "components/CommonForBoth/DeliveryPinModal/DeliveryPinModal";
import { VehicleType } from "enum/VehicleType";
import { FaTags } from 'react-icons/fa';
const TagsIcon = FaTags as unknown as React.FC<{ className?: string }>;
import { useNavigate } from "react-router-dom";
import { CreditCardService } from "services/CreditCardService";
import { getMinimumDeliveryDateTime, getSerivceSettingsType, isDeliveryAtLeastTwoHoursAfterPickup, normalizeMomentToMinute } from "helpers/formHelpers";
import { Util } from "Util";
export interface Payment {
  Name?: string;
  CardNumber?: number;
  ExpireDate?: Date;
  code?: string;
}

const PlaceOrdersBusiness: React.FC = () => {
  const TORONTO_TIMEZONE = "America/Toronto";

  const [activeTab, setactiveTab] = useState(1);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [picup, setPicUpAddress] = useState<AddressModel>();
  const [deliver, setDeliverAddress] = useState<AddressModel>();
  const [orderDetailsRespose, setOrderDetailsRespose] = useState<OrderResponse>({} as OrderResponse);
  const [orderRespose, setOrderRespose] = useState<OrderResponse>({} as OrderResponse);
  const [pickupDateTime, setPickupDateTime] = useState<moment.Moment>(moment.tz("America/Toronto"));
  const [deliveryDateTime, setDeliveryDateTime] = useState(moment.tz("America/Toronto").add(5, "hours"));
  const [ispickupDateModified] = useState(false);
  const [errorMessage] = useState("");
  const [isClicked, setIsClicked] = useState<boolean>(false);
  const [, setIsPicked] = useState<boolean>(false);
  const [isDeliverClicked, setIsDeliverClicked] = useState<boolean>(false);
  const [, setIsChecked] = useState<boolean>(false);
  const canadianPhoneRegExp = /^(?:(?:\+1|1-)?(?:\(\d{3}\)|\d{3})[-.]\d{3}[-.]\d{4}|(?:\+1|1-)?\d{10})$/;
  const [user] = useAuth() as AuthData;
  const [, setNotification] = useNotification() as NotificationData;
  const [, setDispachCount] = useDispachCount();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [promoCode, setPromoCode] = useState('');
  const currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + 5);
  const [userData, setUserData] = useState<boolean>(false);
  const [mindate, setMindate] = useState(moment.tz("America/Toronto"));
  const [isSubmittingOrder, setIsSubmittingOrder] = useState(false);
  const [promoInput, setPromoInput] = useState('');
  const [promoError, setPromoError] = useState('');
  const [promosEnabled, setPromosEnabled] = useState(false);
  const [picvalue, setpicValue] = useState<InputValueType>({
    label: "",
    placeId: "",
  });
  const [delvalue, setdelValue] = useState<InputValueType>({
    label: "",
    placeId: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [deliveryPin, setDeliveryPin] = useState('');
  const pendingSubmissionRef = useRef<{
    payload: string;
    idempotencyKey: string;
    traceId: string;
  } | undefined>(undefined);

  const [appliedPromo, setAppliedPromo] = useState<{
    code: string;
    discountPercent: number;
    discountAmount: number;
    discountedSubTotal: number;
    discountedTotalFare: number;
    discountedHst: number;
  } | null>(null);

  const handleClosePinModal = () => setShowModal(false);


  const handleMouseDown = (value: DeliverOption) => {
    if (value === DeliverOption.DELIVERY_VERIFICATION_PIN) {
      setShowModal(true);
    }
    setFieldValue("deliveryOption", value);
  };

  const datePickerDateToTorontoMoment = (date: Date) =>
    normalizeMomentToMinute(
      moment.tz(
        {
          year: date.getFullYear(),
          month: date.getMonth(),
          date: date.getDate(),
          hour: date.getHours(),
          minute: date.getMinutes(),
          second: date.getSeconds(),
          millisecond: date.getMilliseconds(),
        },
        TORONTO_TIMEZONE
      )
    );

  const torontoMomentToDatePickerDate = (date: moment.Moment) =>
    new Date(date.year(), date.month(), date.date(), date.hour(), date.minute(), date.second(), date.millisecond());

  const validateAndCorrectTime = (date: Date) => {
    const pickupDateTimeObj = datePickerDateToTorontoMoment(date);
    const currentTime = normalizeMomentToMinute(moment().tz(TORONTO_TIMEZONE));

    const minTime = moment(pickupDateTimeObj).set({ hour: 9, minute: 0, second: 0, millisecond: 0 });
    let maxTime = moment(pickupDateTimeObj).set({ hour: 21, minute: 0, second: 0, millisecond: 0 });

    if (pickupDateTimeObj.isSame(currentTime, 'day')) {
      if (pickupDateTimeObj.isBefore(currentTime)) {
        // If the selected date is today and the time is in the past, round up to the next valid time
        const roundedTime = moment(currentTime).add(15 - (currentTime.minute() % 15), 'minutes').startOf('minute');
        return roundedTime;
      } else if (pickupDateTimeObj.isBefore(minTime)) {
        // If the selected date is today and the time is before 9:00 AM, set to business start
        return minTime;
      } else if (pickupDateTimeObj.isAfter(maxTime)) {
        // If the selected date is today and the time is after maxTime, set to maxTime
        return maxTime;
      }
    } else {
      if (pickupDateTimeObj.isBefore(minTime)) {
        return minTime;
      } else if (pickupDateTimeObj.isAfter(maxTime)) {
        return maxTime;
      }
    }

    return pickupDateTimeObj;
  };

  const handlePickupDateChange = (date: Date) => {
    const correctedDate = validateAndCorrectTime(date);
    setPickupDateTime(correctedDate);
    handleDeliverDatefromPickupChange(correctedDate);
  };

  const handleDeliverDatefromPickupChange = (date: moment.Moment | Date | null) => {
    if (!date) return;

    const pickup = normalizeMomentToMinute(moment.isMoment(date) ? date.clone() : datePickerDateToTorontoMoment(date));
    const pickupHour = pickup.hour();

    let maxHour = 17; // default 5 PM
    if (pickupHour >= 15) maxHour = 18; // ≥ 3 PM → 6 PM
    if (pickupHour >= 16) maxHour = 19; // ≥ 4 PM → 7 PM
    if (pickupHour >= 17) maxHour = 20; // ≥ 5 PM → 8 PM
    if (pickupHour >= 18) maxHour = 21; // ≥ 6 PM → 9 PM
    if (pickupHour >= 19) maxHour = 22; // ≥ 7 PM → 10 PM
    if (pickupHour >= 20) maxHour = 23; // ≥ 8 PM → 11 PM
    setDeliveryDateTime(pickup.clone().set({ hour: maxHour, minute: 0, second: 0, millisecond: 0 }));
  }

  const navigate = useNavigate();

  const handleDeliveryDateChange = (date: Date | null) => {
    if (!date) return;

    const deliveryDate = datePickerDateToTorontoMoment(date);

    let maxDeliveryTime = deliveryDate.clone().set({ hour: 17, minute: 0, second: 0, millisecond: 0 }); // default 5 PM

    if (pickupDateTime.hour() >= 17) {
      maxDeliveryTime = deliveryDate.clone().set({ hour: 23, minute: 0, second: 0, millisecond: 0 });
    } else if (pickupDateTime.hour() >= 15) {
      maxDeliveryTime = deliveryDate.clone().set({ hour: 21, minute: 0, second: 0, millisecond: 0 });
    }

    if (deliveryDate.isAfter(maxDeliveryTime)) {
      toast.error(`Delivery time cannot be after ${maxDeliveryTime.format("HH:mm")}. Setting to ${maxDeliveryTime.format("HH:mm")}.`, {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
      setDeliveryDateTime(maxDeliveryTime);
      return;
    } else if (!isDeliveryAtLeastTwoHoursAfterPickup(pickupDateTime, deliveryDate)) {
      toast.error("Delivery date must be at least two hours after the pickup date and time.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
      return;
    } else {
      setDeliveryDateTime(deliveryDate);
    }
  };

  const getDeliveryMinTime = () => {
    const now = normalizeMomentToMinute(moment().tz(TORONTO_TIMEZONE));
    const pickupPlus2Hours = getMinimumDeliveryDateTime(pickupDateTime);

    if (pickupDateTime.isSame(now, "day")) {
      const roundedNow = now.clone().add(15 - (now.minute() % 15), "minutes").startOf("minute");
      return torontoMomentToDatePickerDate(moment.max(pickupPlus2Hours, roundedNow));
    }
    return torontoMomentToDatePickerDate(pickupPlus2Hours);
  };

  const getDeliveryMaxTime = () => {
    const pickupMoment = moment(pickupDateTime);
    const pickupHour = pickupDateTime.hour();
    const two45PM = pickupMoment.clone().set({ hour: 14, minute: 45, second: 0, millisecond: 0 });

    let maxHour = 17;
    if (pickupMoment.isAfter(two45PM)) {
      maxHour = 21;
    }
    if (pickupHour > 18) {
      maxHour = 23;
    }
    return torontoMomentToDatePickerDate(moment(pickupDateTime)
      .set({ hour: maxHour, minute: 0, second: 0, millisecond: 0 })
    );
  };

  const getPickupMinTime = () => {
    const now = moment().tz(TORONTO_TIMEZONE);
    const businessStart = pickupDateTime.clone().set({ hour: 9, minute: 0, second: 0, millisecond: 0 });

    if (pickupDateTime.isSame(now, "day")) {
      const roundedNow = roundUpToNext15Min(now.clone());
      return torontoMomentToDatePickerDate(moment.max(businessStart, roundedNow));
    }

    return torontoMomentToDatePickerDate(businessStart);
  };

  const getPickupMaxTime = () => {
    return torontoMomentToDatePickerDate(pickupDateTime.clone().set({ hour: 21, minute: 0, second: 0, millisecond: 0 }));
  };

  useEffect(() => {
    OrderService.getPromoEnabled().then(res => {
      if (res.success) {
        setPromosEnabled(res?.data?.data?.enabled || false);
      }
    });
  }, [])

  useEffect(() => {
    setFieldValue("pickupUnit", user?.address?.unit);
    setFieldValue("pickupContactPhone", user?.address?.contactPhone);
    setFieldValue("pickupContactName", user?.address?.contactName);
    setFieldValue("companyName", user?.address?.companyName);

    if (user?.address?.city != "" && user?.address?.city != null && user?.address?.city != undefined) {
      setpicValue({ label: user?.address?.city, placeId: "" });
    } else {
      setpicValue({ label: "", placeId: "" });
    }
    setPicUpAddress({
      city: user?.address?.city,
      lat: user?.address?.lat,
      lng: user?.address?.lng,
      postalCode: user?.address?.postalCode,
      companyName: user?.businessName,
    });
    setIsPicked(true);

    const toronto = normalizeMomentToMinute(moment.tz(TORONTO_TIMEZONE));

    if (toronto.hour() >= 9 && toronto.hour() < 21) {
      const pickup = toronto.clone();
      const pickupHour = pickup.hour();
      const roundedTime = roundUpToNext15Min(toronto.clone());

      setPickupDateTime(roundedTime);
      setMindate(pickup);

      let maxHour = 17; // default 5 PM
      if (pickupHour >= 15) maxHour = 18; // ≥ 3 PM → 6 PM
      if (pickupHour >= 16) maxHour = 19; // ≥ 4 PM → 7 PM
      if (pickupHour >= 17) maxHour = 20; // ≥ 5 PM → 8 PM
      if (pickupHour >= 18) maxHour = 21; // ≥ 6 PM → 9 PM
      if (pickupHour >= 19) maxHour = 22; // ≥ 7 PM → 10 PM
      if (pickupHour >= 20) maxHour = 23; // ≥ 8 PM → 11 PM

      setDeliveryDateTime(pickup.hour(maxHour).minute(0).second(0).millisecond(0));
    } else if (toronto.hour() >= 21) {
      const nextBusinessDay = toronto.clone().add(1, "days");
      setMindate(nextBusinessDay.clone());
      setPickupDateTime(nextBusinessDay.clone().hour(9).minute(0).second(0).millisecond(0));
      setDeliveryDateTime(nextBusinessDay.clone().hour(17).minute(0).second(0).millisecond(0));
    } else {
      setPickupDateTime(toronto.clone().hour(9).minute(0).second(0).millisecond(0));
      setDeliveryDateTime(toronto.clone().hour(17).minute(0).second(0).millisecond(0));
    }

    NotificationService.getNotifications(5, 0).then(res => {
      if (res.count !== undefined) {
        setNotification(res.count);
      }
    });

  }, [userData]);

  function roundUpToNext15Min(momentDate: any) {
    const remainder = 15 - (momentDate.minute() % 15);
    if (remainder !== 15) {
      return momentDate.add(remainder, 'minutes').startOf('minute');
    }
    return momentDate.startOf('minute');
  }

  const initialValues = {
    pickupUnit: "",
    pickupContactPhone: "",
    pickupContactName: "",
    companyName: "",
    pickUpAddressBook: "",
    deliverAddressBook: "",
    deliverUnit: "",
    deliverContactPhone: "",
    deliverContactName: "",
    deliverCompany: "",
    vehicleType: "",
    totalWeight: "",
    totalItems: "",
    description: "",
    deliveryOption: "",
    deliveryPin: "",
    note: "",
    sentBy: "",
    sizeDescription: ""
  };

  const getDeails = async (values: typeof initialValues): Promise<boolean> => {
    const submitData: Order = {
      pickup: picup,
      deliver: deliver,
      deliveryOption: values.deliveryOption,
      deliveryTime: moment(deliveryDateTime).tz("America/Toronto").format(),
      packageReadyTime: moment(pickupDateTime).tz("America/Toronto").format(),
      totalItems: values.totalItems,
      totalWeight: values.totalWeight.toString() + " pounds",
      vehicleType: values.vehicleType,
      notes: values.description,
      settingsType: getSerivceSettingsType(pickupDateTime, deliveryDateTime),
    };

    try {
      const res: { success: any; data: any } = await OrderService.orderDetails(submitData);

      if (res.success) {
        setOrderDetailsRespose(res.data);
        return true;
      } else {
        toast.error("error occured", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
        return false;
      }
    } catch (error) {
      toast.error("Something went wrong", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
      return false;
    }
  };

  const mapprops: any = {
    componentRestrictions: { country: "ca" },
    locationRestriction: {
      north: 56.85, // Northeast corner latitude (Keep this as is)
      south: 41.6, // Southwest corner latitude (Keep this as is)
      east: -74.0, // Adjusted Northeast corner longitude to cover Kingston and Cornwall
      west: -95.15, // Keep this as is to cover the entire Ontario province
    },
  };

  const handleApplyPromo = async () => {
    if (!promoInput.trim()) {
      setPromoError("Please enter a promo code");
      return;
    }
    if (!orderDetailsRespose?.uniqueId) {

      throw new Error("Order ID is required");
    }
    const validation = await OrderService.validatePromoCode(
      promoInput,
      orderRespose?._id
    );

    if (validation.error) {
      toast.error(`${validation.error}`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    setAppliedPromo({
      code: validation?.data?.code,
      discountPercent: validation?.data?.discountPercent,
      discountAmount: validation?.data?.discountAmount,
      discountedSubTotal: validation?.data?.discountedSubTotal,
      discountedTotalFare: validation?.data?.discountedTotalFare,
      discountedHst: validation?.data?.discountedHst,
    });

    setPromoError('');
    setIsModalOpen(false);
    setPromoCode(` ${validation?.data?.discountPercent}% discount applied`)
    toast.success(`${validation?.data?.discountPercent}% discount applied!`, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  };

  const getDiscountedTotals = () => {
    if (!appliedPromo || !orderRespose?.subTotal) return orderRespose;
    const discountedSubTotal = appliedPromo?.discountedSubTotal ?? 0;
    const discountedHst = appliedPromo?.discountedHst ?? 0;
    const discountedTotalFare = appliedPromo?.discountedTotalFare ?? 0;

    return {
      ...orderRespose,
      subTotal: discountedSubTotal,
      hst: discountedHst,
      totalFare: discountedTotalFare
    };
  };

  const checkPickUpTime = () => {
    const currentTime = moment()
      .tz('America/Toronto')
      .second(0)
      .millisecond(0);

    const selectedPickupTime = moment.tz(
      {
        year: pickupDateTime.year(),
        month: pickupDateTime.month(),
        date: pickupDateTime.date(),
        hour: pickupDateTime.hour(),
        minute: pickupDateTime.minute(),
        second: 0,
        millisecond: 0
      },
      'America/Toronto'
    );
    if (selectedPickupTime.isBefore(currentTime)) {
      toast.error("Pickup time cannot be in the past.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });

      const correctedPickupTime = roundUpToNext15Min(moment.tz(TORONTO_TIMEZONE));
      setPickupDateTime(correctedPickupTime);
      handleDeliverDatefromPickupChange(correctedPickupTime);
      setactiveTab(1);
      return false;
    }

    return true;
  }

  const finalOrder = appliedPromo ? getDiscountedTotals() : orderRespose;

  const onSubmit = async (values: typeof initialValues, actions: any) => {
    if (isSubmittingOrder) return;
    if (!checkPickUpTime()) {
      actions.setSubmitting(false);
      return;
    }

    setIsSubmittingOrder(true);

    const submitData: Order = {
      pickup: picup,
      deliver: deliver,
      deliveryOption: values.deliveryOption,
      deliveryTime: moment(deliveryDateTime).tz("America/Toronto").format(),
      packageReadyTime: moment(pickupDateTime).tz("America/Toronto").format(),
      totalItems: values.totalItems,
      totalWeight: values.totalWeight.toString() + " pounds",
      vehicleType: values.vehicleType,
      paymentOption: user?.paymentOption,
      sentBy: values.sentBy,
      notes: values.note,
      descriptions: values.description,
      sizeDescription: values.sizeDescription,
      deliveryPin: deliveryPin,
      settingsType: getSerivceSettingsType(pickupDateTime, deliveryDateTime),
    };
    const payload = JSON.stringify(submitData);
    if (!pendingSubmissionRef.current || pendingSubmissionRef.current.payload !== payload) {
      pendingSubmissionRef.current = {
        payload,
        idempotencyKey: Util.createClientTraceId("web-customer-order-submit"),
        traceId: Util.createClientTraceId("web-customer-order"),
      };
    }

    try {
      const res = await OrderService.createOrder(submitData, pendingSubmissionRef.current);
      const isValidSuccess =
        res?.success === true &&
        Boolean(res?.data?._id) &&
        Boolean(res?.data?.uniqueId);

      if (isValidSuccess) {
        setOrderRespose(res.data);
        pendingSubmissionRef.current = undefined;

        try {
          await Promise.all([
            NotificationService.getNotifications(5, 0).then(notificationResponse => {
              if (notificationResponse.count !== undefined) {
                setNotification(notificationResponse.count);
              }
            }),
            statuscount(),
          ]);
        } catch (refreshError) {
          console.warn("Order created, but list/count refresh failed.", refreshError);
        }

        actions.resetForm();

        if (
          res.data.orderType === "draft" ||
          res.data.submissionStatus === "payment_required"
        ) {
          const orderIdList = [res.data._id];
          const totalFare = res.data.totalFare?.toFixed(2);
          navigate(`/${user?.role}/payment-card`, {
            state: {
              orderIdList,
              paymentType: PaymentType.ORDER,
              totalFare,
            },
          });
          return;
        }

        toast.success("Successfully placed order.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
        navigate(`/${user?.role}/current-orders`, {
          state: {
            message: `Order ${res.data.uniqueId} was created successfully.`,
          },
        });
      } else {
        const invalidResponse = res?.success
          ? {
              ...res,
              error: "The server returned an invalid order confirmation. Your form has been preserved.",
              traceId: res.traceId || pendingSubmissionRef.current?.traceId,
            }
          : res;
        toast.error(Util.getOrderSubmitErrorMessage(invalidResponse), {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      }
    } catch (error) {
      toast.error(Util.getOrderSubmitErrorMessage({ error }), {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
    } finally {
      setIsSubmittingOrder(false);
      actions.setSubmitting(false);
    }
  };

  function toggleTab(tab: number): void {
    if (activeTab !== tab && activeTab !== 4) {
      const modifiedSteps = [...passedSteps, tab];
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
  }

  function toggleTab1(tab: number): void {
    if (activeTab !== 4) {
      if (picup?.city == "" || picup?.city == undefined) {
        toast.error("Pick-Up Address is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.pickupContactName == "") {
        toast.error("Contact Name is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (ispickupDateModified == true) {
        toast.error("Invalid date or time selected", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.pickupContactPhone != "" && !canadianPhoneRegExp.test(values.pickupContactPhone)) {
        toast.error("Invalid Canadian phone number", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (activeTab !== tab) {
        const modifiedSteps = [...passedSteps, tab];
        if (tab >= 1 && tab <= 4) {
          setactiveTab(tab);
          setPassedSteps(modifiedSteps);
        }
      }
    }
  }

  async function toggleTab2(tab: number): Promise<void> {
    if (activeTab !== 4) {
      if (picup?.city == "" || picup?.city == undefined) {
        toast.error("pick up Address is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (deliver?.city == "" || deliver?.city == undefined) {
        toast.error("Delivery Address is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.deliverContactName == "") {
        toast.error("Contact Name is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.deliveryOption == "--select delivery option--") {
        toast.error("Delivery Option is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.deliverContactPhone != "" && !canadianPhoneRegExp.test(values.deliverContactPhone)) {
        toast.error("Invalid phone number", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.vehicleType == "") {
        toast.error("Vehicle Type is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.totalWeight == "") {
        toast.error("Total weight is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.totalWeight < "1") {
        toast.error("Total weight cannot be negative", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.totalItems == "") {
        toast.error("Total Items is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.totalItems < "1") {
        toast.error("Total Items cannot be negative", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (values.deliveryOption == DeliverOption.DELIVERY_VERIFICATION_PIN && !deliveryPin) {
        toast.error("Delivery pin is required", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      } else if (activeTab !== tab) {
        setPicUpAddress({
          ...picup,
          unit: values.pickupUnit,
          contactPhone: values.pickupContactPhone,
          contactName: values.pickupContactName,
          companyName: values.companyName,
        });
        setDeliverAddress({
          ...deliver,
          unit: values.deliverUnit,
          contactPhone: values.deliverContactPhone,
          contactName: values.deliverContactName,
          companyName: values.deliverCompany,
        });
        const isSuccess = await getDeails(values);
        const modifiedSteps = [...passedSteps, tab];
        if (isSuccess && tab >= 1 && tab <= 4) {
          setactiveTab(tab);
          setPassedSteps(modifiedSteps);
        }
      }
    }
  }

  const handleAddress = async (label: string, place_id: string, type: string) => {
    if (place_id !== "") {
      const address = label;
      await geocodeByPlaceId(place_id)
        .then(([place]: google.maps.GeocoderResult[]) => {
          const { long_name: postalCode = "" } = place.address_components.find(c => c.types.includes("postal_code")) || {};
          const latLng = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
          if (type == AddressType.pickup) {
            setFieldValue("pickupUnit", "");
            setPicUpAddress({ city: address, lat: latLng.lat, lng: latLng.lng, postalCode: postalCode });
          } else if (type == AddressType.delivery) {
            setFieldValue("deliverUnit", "");
            setDeliverAddress({ city: address, lat: latLng.lat, lng: latLng.lng, postalCode: postalCode });
          } else {
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  const handlePayment = async () => {
    try {
      if (!user?.email) {
        throw new Error("User email is required");
      }

      const orderId = orderRespose._id;
      const orderIdList = [orderId];
      const totalFare = finalOrder?.totalFare?.toFixed(2)
      const paymentType = PaymentType.ORDER;
      if (orderId) {
        navigate(`/${user.role}/payment-card/${promoInput}`, {
          state: { orderIdList, paymentType, totalFare },
        });
      } else {
        console.error("Order ID not found.");
      }
    } catch (error) {
      console.error("Order create error", error);
    }
  };

  const { values, errors, touched, handleBlur, handleChange, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      pickupUnit: "",
      pickupContactPhone: "",
      pickupContactName: "",
      companyName: "",
      pickUpAddressBook: "",
      deliverAddressBook: "",
      deliverUnit: "",
      deliverContactPhone: "",
      deliverContactName: "",
      deliverCompany: "",
      vehicleType: "",
      totalWeight: "",
      totalItems: "",
      description: "",
      deliveryOption: "--select delivery option--",
      note: "",
      sentBy: "",
      deliveryPin: "",
      sizeDescription: ""
    },
    validationSchema: user?.isABusiness ? placeOrderSchema : personalPlaceOrderSchema,
    onSubmit,
  });

  const handleRadioChange = (event: RadioChangeEvent) => {
    const selectedValue = event.target.value;
    setFieldValue("vehicleType", selectedValue);
  };

  const handlePickupModal = () => {
    setIsClicked(!isClicked);
  };

  const getAddress = (value: AddressBook) => {
    const pickupAddress: AddressModel = {
      unit: value.address?.unit,
      city: value.address?.city,
      lat: value.address?.lat,
      lng: value.address?.lng,
      postalCode: value.address?.postalCode,
      contactName: value.address?.contactName,
      contactPhone: value.address?.contactPhone,
      street: value.address?.street,
    };
    setpicValue({ label: pickupAddress.city == undefined ? "" : pickupAddress.city, placeId: "" });
    setFieldValue("pickupUnit", pickupAddress.unit ?? "");
    if (pickupAddress.contactPhone != "" && pickupAddress.contactPhone != null && pickupAddress.contactPhone != undefined) {
      setFieldValue("pickupContactPhone", pickupAddress.contactPhone);
    }
    if (pickupAddress.contactName != "" && pickupAddress.contactName != null && pickupAddress.contactName != undefined) {
      setFieldValue("pickupContactName", pickupAddress.contactName);
    }
    if (value.companyName != "" && value.companyName != null && value.companyName != undefined) {
      setFieldValue("companyName", value.companyName);
    }

    setPicUpAddress({ city: pickupAddress.city, lat: pickupAddress.lat, lng: pickupAddress.lng, postalCode: pickupAddress.postalCode });
    setFieldValue("note", value.deliveryNote || "");
  };

  const deleteOrder = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Are You want to Cancel this Order ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Cancel it!",
      cancelButtonText: "No, Continue it!",
    }).then(result => {
      if (result.isConfirmed) {
        setactiveTab(1);
        setUserData(!userData);
      }
    });
  };

  const handleDeliverModal = () => {
    setIsDeliverClicked(!isDeliverClicked);
  };

  const getDeliverAddress = (value: AddressBook) => {
    const DeliverAddres: AddressModel = {
      unit: value.address?.unit,
      city: value.address?.city,
      lat: value.address?.lat,
      lng: value.address?.lng,
      postalCode: value.address?.postalCode,
      contactName: value.address?.contactName,
      contactPhone: value.address?.contactPhone,
      street: value.address?.street,
    };
    setdelValue({ label: DeliverAddres.city == undefined ? "" : DeliverAddres.city, placeId: "" });
    setFieldValue("deliverUnit", DeliverAddres.unit ?? "");
    if (DeliverAddres.contactPhone != "" && DeliverAddres.contactPhone != null && DeliverAddres.contactPhone != undefined) {
      setFieldValue("deliverContactPhone", DeliverAddres.contactPhone);
    }
    if (DeliverAddres.contactName != "" && DeliverAddres.contactName != null && DeliverAddres.contactName != undefined) {
      setFieldValue("deliverContactName", DeliverAddres.contactName);
    }
    if (value.companyName != "" && value.companyName != null && value.companyName != undefined) {
      setFieldValue("deliverCompany", value.companyName);
    }
    setDeliverAddress({ city: DeliverAddres.city, lat: DeliverAddres.lat, lng: DeliverAddres.lng, postalCode: DeliverAddres.postalCode });
    setFieldValue("description", value.deliveryNote || "");
  };

  interface TextWithLineBreaksProps {
    text: string;
  }

  const TextWithLineBreaks: React.FC<TextWithLineBreaksProps> = ({ text }) => {
    const maxCharactersPerRow = 50;
    const lines: string[] = [];

    for (let i = 0; i < text.length; i += maxCharactersPerRow) {
      lines.push(text.slice(i, i + maxCharactersPerRow));
    }

    return (
      <div>
        {lines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
    );
  };

  const statuscount = async () => {
    await AdminService.getalldispachcount().then(res => {
      if (res.success) {
        setDispachCount(res.data);
      } else {
      }
    });
  };

  document.title = "Place Order | Zulu Courier ";
  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <React.Fragment>
        <AddressBookModal isOpen={isClicked} handleIsOpen={handlePickupModal} getAddress={getAddress} setIsChecked={setIsPicked} />
        <AddressBookModal
          isOpen={isDeliverClicked}
          handleIsOpen={handleDeliverModal}
          getAddress={getDeliverAddress}
          setIsChecked={setIsChecked}
        />
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Place Order" breadcrumbItem="Create Order" />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <div className="wizard clearfix">
                      <div className="steps clearfix">
                        <ul>
                          <NavItem className={classnames({ current: activeTab === 1 })}>
                            <NavLink
                              className={classnames({ current: activeTab === 1 })}
                              onClick={() => {
                                toggleTab(1);
                              }}
                              to={""} // disabled={!(passedSteps || []).includes(1)}
                            >
                              <span className="number">1</span> Add Pick - Up Details
                            </NavLink>
                          </NavItem>
                          <NavItem className={classnames({ current: activeTab === 2 })}>
                            <NavLink
                              className={classnames({ active: activeTab === 2 })}
                              onClick={() => {
                                toggleTab1(2);
                              }}
                              to={""} // disabled={!(passedSteps || []).includes(2)}
                            >
                              <span className="number">2</span> Add Delivery Details
                            </NavLink>
                          </NavItem>
                          <NavItem className={classnames({ current: activeTab === 3 })}>
                            <NavLink
                              className={classnames({ active: activeTab === 3 })}
                              onClick={() => {
                                handleDeliveryDateChange(torontoMomentToDatePickerDate(deliveryDateTime));
                                toggleTab2(3);
                              }}
                              to={""} // disabled={!(passedSteps || []).includes(3)}
                            >
                              <span className="number">3</span> Confirm Details
                            </NavLink>
                          </NavItem>
                          <NavItem className={classnames({ current: activeTab === 4 })}>
                            <NavLink
                              className={classnames({ active: activeTab === 4 })}
                              to={""} // disabled={!(passedSteps || []).includes(2)}
                            >
                              <span className="number">4</span> Add Payment Details
                            </NavLink>
                          </NavItem>
                        </ul>
                      </div>
                      <div className="content clearfix">
                        <TabContent activeTab={activeTab} className="body">
                          <TabPane tabId={1}>
                            <Form>
                              <Row>
                                <Col lg="6">
                                  <>
                                    <div className="mb-3 form-group">
                                      <div className="d-flex flex-wrap align-items-center justify-content-start mb-2">
                                        <Label for="basicpill-firstname-input1 input-title" className="place-order-title me-2 me-sm-0 justify-content-center text-center mb_sm_0">
                                          Pick - Up Address <Label className="title-star">*</Label>
                                        </Label>
                                        <div className="label-wrap" onClick={handlePickupModal}>
                                          <span className="custom-label">{"Use Address Book"}</span>
                                        </div>
                                      </div>

                                      <div>
                                        <CustomGooglePlacesAutocompleteOrders
                                          apiKey={environment.google_maps_key}
                                          autocompletionRequest={mapprops}
                                          value={picvalue}
                                          setValue={setpicValue}
                                          addressType={AddressType.pickup}
                                          selectProps={{
                                            name: "address",
                                          }}
                                          handleAddress={handleAddress}
                                        />
                                      </div>
                                    </div>
                                  </>
                                </Col>
                                <Col lg="6">
                                  <div className="mb-3 form-group">
                                    <Label for="basicpill-lastname-input2" className="place-order-title">
                                      Unit Number <Label className="py-2"></Label>
                                    </Label>
                                    <input
                                      value={values.pickupUnit}
                                      onChange={handleChange}
                                      id="pickupUnit"
                                      type="text"
                                      placeholder=""
                                      onBlur={handleBlur}
                                      className={
                                        errors.pickupUnit && touched.pickupUnit
                                          ? "input-error form-control unit-number py-2"
                                          : "form-control  unit-number py-2"
                                      }
                                    />
                                    {errors.pickupUnit && touched.pickupUnit && (
                                      <p className="error place-order-title">{errors.pickupUnit}</p>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3 form-group">
                                    <Label for="basicpill-phoneno-input3" className="place-order-title">
                                      Contact Name <Label className="title-star">*</Label>
                                    </Label>
                                    <input
                                      value={values.pickupContactName}
                                      onChange={handleChange}
                                      id="pickupContactName"
                                      type="text"
                                      placeholder=""
                                      onBlur={handleBlur}
                                      className={
                                        errors.pickupContactName && touched.pickupContactName ? "input-error form-control" : "form-control"
                                      }
                                    />
                                    {errors.pickupContactName && touched.pickupContactName && (
                                      <p className="error place-order-title">{errors.pickupContactName}</p>
                                    )}
                                  </div>
                                </Col>
                                <Col lg="6">
                                  <div className="mb-3 form-group">
                                    <Label for="basicpill-email-input4" className="place-order-title">
                                      Contact Phone <Label className="py-2"></Label>
                                    </Label>
                                    <input
                                      value={values.pickupContactPhone}
                                      onChange={handleChange}
                                      id="pickupContactPhone"
                                      type="text"
                                      placeholder=""
                                      onBlur={handleBlur}
                                      className={
                                        errors.pickupContactPhone && touched.pickupContactPhone
                                          ? "input-error form-control"
                                          : "form-control"
                                      }
                                    />
                                    {errors.pickupContactPhone && touched.pickupContactPhone && (
                                      <p className="error place-order-title">{errors.pickupContactPhone}</p>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3 form-group">
                                    <Label for="basicpill-phoneno-input3" className="place-order-title">
                                      Pickup date & time <Label className="title-star">*</Label>
                                    </Label>
                                    <DatePicker
                                      onFocus={(e) => e.target.blur()}
                                      selected={pickupDateTime ? torontoMomentToDatePickerDate(pickupDateTime) : null}
                                      onChange={handlePickupDateChange}
                                      showTimeSelect
                                      timeFormat="HH:mm"
                                      timeIntervals={15}
                                      dateFormat="yyyy-MM-dd HH:mm"
                                      timeCaption="Time"
                                      placeholderText="Select Date and Time"
                                      className="form-control"
                                      minDate={torontoMomentToDatePickerDate(mindate)}
                                      maxDate={torontoMomentToDatePickerDate(moment().tz(TORONTO_TIMEZONE).add(1, "year"))}
                                      minTime={getPickupMinTime()}
                                      maxTime={getPickupMaxTime()}
                                    />
                                    {ispickupDateModified && <p className="error place-order-title">{errorMessage}</p>}
                                  </div>
                                </Col>
                                <Col lg="6">
                                  <div className="mb-3 form-group">
                                    <Label for="basicpill-email-input4" className="place-order-title">
                                      Company Name <Label className="py-2"></Label>
                                    </Label>
                                    <input
                                      value={values.companyName}
                                      onChange={handleChange}
                                      id="companyName"
                                      type="text"
                                      placeholder=""
                                      onBlur={handleBlur}
                                      className={errors.companyName && touched.companyName ? "input-error form-control" : "form-control"}
                                    />
                                    {errors.companyName && touched.companyName && (
                                      <p className="error place-order-title">{errors.companyName}</p>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3 form-group">
                                    <Label for="basicpill-address-input2" className="place-order-title">
                                      Note
                                      <Label className="title-star">
                                        <Label className="title-star"></Label>
                                      </Label>
                                    </Label>
                                    <input
                                      value={values.note}
                                      onChange={handleChange}
                                      id="note"
                                      type="text"
                                      placeholder=""
                                      onBlur={handleBlur}
                                      className="form-control"
                                    />
                                  </div>
                                </Col>
                                <Col lg="6">
                                  <div className="mb-3 form-group">
                                    <Label for="basicpill-address-input2" className="place-order-title">
                                      Item Description / Size (optional)
                                      <Label className="title-star">
                                        <Label className="title-star"></Label>
                                      </Label>
                                    </Label>
                                    <input
                                      value={values.sizeDescription}
                                      onChange={handleChange}
                                      id="sizeDescription"
                                      type="text"
                                      placeholder=""
                                      onBlur={handleBlur}
                                      className="form-control"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Form>
                          </TabPane>
                          <TabPane tabId={2}>
                            <div>
                              <Form>
                                <Row>
                                  <Col lg="6" md="12">
                                    <>
                                      <div className="mb-3 form-group">
                                        <div className="d-flex flex-wrap align-items-center">
                                          <Label for="basicpill-firstname-input1 input-title" className="place-order-title">
                                            Delivery Address<Label className="title-star">*</Label>
                                          </Label>
                                          <div className="label-wrap" onClick={handleDeliverModal}>
                                            <span className="custom-label">{"Use Address Book"}</span>
                                          </div>
                                        </div>

                                        <div>
                                          <CustomGooglePlacesAutocompleteOrders
                                            apiKey={environment.google_maps_key}
                                            autocompletionRequest={mapprops}
                                            addressType={AddressType.delivery}
                                            value={delvalue}
                                            setValue={setdelValue}
                                            selectProps={{
                                              name: "address",
                                            }}
                                            handleAddress={handleAddress}
                                          />
                                        </div>
                                      </div>
                                    </>
                                  </Col>

                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label for="basicpill-vatno-input6" className="place-order-title">
                                        Unit Number <Label className="py-2"></Label>
                                      </Label>
                                      <input
                                        value={values.deliverUnit}
                                        onChange={handleChange}
                                        id="deliverUnit"
                                        type="text"
                                        placeholder=""
                                        onBlur={handleBlur}
                                        className={
                                          errors.deliverUnit && touched.deliverUnit
                                            ? "input-error form-control unit-number py-2"
                                            : "form-control unit-number py-2"
                                        }
                                      />
                                      {errors.deliverUnit && touched.deliverUnit && (
                                        <p className="error place-order-title">{errors.deliverUnit}</p>
                                      )}
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label for="basicpill-cstno-input7" className="place-order-title">
                                        Contact Name<Label className="title-star">*</Label>
                                      </Label>
                                      <input
                                        value={values.deliverContactName}
                                        onChange={handleChange}
                                        id="deliverContactName"
                                        type="text"
                                        placeholder=""
                                        onBlur={handleBlur}
                                        className={
                                          errors.deliverContactName && touched.deliverContactName
                                            ? "input-error form-control"
                                            : "form-control"
                                        }
                                      />
                                      {errors.deliverContactName && touched.deliverContactName && (
                                        <p className="error place-order-title">{errors.deliverContactName}</p>
                                      )}
                                    </div>
                                  </Col>

                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label for="basicpill-servicetax-input8" className="place-order-title">
                                        Contact Phone <Label className="py-2"></Label>
                                      </Label>
                                      <input
                                        value={values.deliverContactPhone}
                                        onChange={handleChange}
                                        id="deliverContactPhone"
                                        type="text"
                                        placeholder=""
                                        onBlur={handleBlur}
                                        className={
                                          errors.deliverContactPhone && touched.deliverContactPhone
                                            ? "input-error form-control"
                                            : "form-control"
                                        }
                                      />
                                      {errors.deliverContactPhone && touched.deliverContactPhone && (
                                        <p className="error place-order-title">{errors.deliverContactPhone}</p>
                                      )}
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label for="basicpill-declaration-input10" className="place-order-title">
                                        Choose vehicle<Label className="title-star">*</Label>
                                      </Label>
                                      <div className="col-lg-6 form-check">
                                        <Radio.Group value={values.vehicleType} onChange={handleRadioChange} onBlur={handleBlur}>
                                          <Radio value={VehicleType.CAR}>Car</Radio>
                                          <Radio value={VehicleType.SUV}>SUV</Radio>
                                          <Radio value={VehicleType.VAN}>Mini Van</Radio>
                                        </Radio.Group>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label for="basicpill-companyuin-input9" className="place-order-title">
                                        Company Name<Label className="title-star"></Label>
                                      </Label>
                                      <input
                                        value={values.deliverCompany}
                                        onChange={handleChange}
                                        id="deliverCompany"
                                        type="text"
                                        placeholder=""
                                        onBlur={handleBlur}
                                        className="form-control"
                                      />
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label for="basicpill-companyuin-input9" className="place-order-title">
                                        Total weight of all the items(lbs)<Label className="title-star">*</Label>
                                      </Label>
                                      <input
                                        value={values.totalWeight}
                                        onChange={handleChange}
                                        id="totalWeight"
                                        type="number"
                                        placeholder=""
                                        onBlur={handleBlur}
                                        min={1}
                                        className={errors.totalWeight && touched.totalWeight ? "input-error form-control" : "form-control"}
                                      />

                                      {errors.totalWeight && touched.totalWeight && (
                                        <p className="error place-order-title">{errors.totalWeight}</p>
                                      )}
                                    </div>
                                  </Col>

                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label for="basicpill-declaration-input10" className="place-order-title">
                                        Total number of the items<Label className="title-star">*</Label>
                                      </Label>
                                      <input
                                        value={values.totalItems}
                                        onChange={handleChange}
                                        id="totalItems"
                                        type="number"
                                        placeholder=""
                                        onBlur={handleBlur}
                                        min={1}
                                        className={errors.totalItems && touched.totalItems ? "input-error form-control" : "form-control"}
                                      />
                                      {errors.totalItems && touched.totalItems && (
                                        <p className="error place-order-title">{errors.totalItems}</p>
                                      )}
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label for="basicpill-phoneno-input3" className="place-order-title">
                                        Delivery date & time <Label className="title-star">*</Label>
                                      </Label>

                                      <DatePicker
                                        onFocus={(e) => e.target.blur()}
                                        selected={deliveryDateTime ? torontoMomentToDatePickerDate(deliveryDateTime) : null}
                                        onChange={handleDeliveryDateChange}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={15}
                                        dateFormat="yyyy-MM-dd HH:mm"
                                        timeCaption="Time"
                                        placeholderText="Select Date and Time"
                                        minDate={torontoMomentToDatePickerDate(pickupDateTime)}
                                        maxDate={torontoMomentToDatePickerDate(pickupDateTime)}
                                        minTime={getDeliveryMinTime()}
                                        maxTime={getDeliveryMaxTime()}
                                        className="form-control"
                                      />
                                    </div>
                                  </Col>

                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label className="place-order-title">
                                        Delivery method / handling (if unavailable)<Label className="title-star">*</Label>
                                      </Label>
                                      <Select
                                        value={values.deliveryOption}
                                        className="form-select"
                                        placeholder="Select Card Type"
                                        defaultValue={DeliverOption.DROP_AT_DOOR}
                                        onChange={(value: SelectValue) => {
                                          setFieldValue("deliveryOption", value);

                                          if (value !== DeliverOption.DELIVERY_VERIFICATION_PIN) {
                                            setDeliveryPin("");
                                          }
                                        }}
                                      >
                                        {user?.paymentOption === PaymentOption.SINGLE ? (
                                          <>
                                            <option value={DeliverOption.DROP_AT_DOOR} className="place-order-title">
                                              Drop at door
                                            </option>
                                            <option value={DeliverOption.DROP_AT_MAILBOX}>Drop at mailbox</option>
                                            <option value={DeliverOption.DROP_AT_FRONT_DESK}>Drop at front desk</option>
                                            <option value={DeliverOption.CALL_ME_TO_CONFIRM}>Call me to confirm</option>
                                            <option value={DeliverOption.DELIVERY_VERIFICATION_PIN} onMouseDown={() => handleMouseDown(DeliverOption.DELIVERY_VERIFICATION_PIN)}    >Delivery Verification Pin</option>
                                            <option value={DeliverOption.SIGNATURE_REQUIRED}>Signature Required</option>

                                          </>) : (
                                          <>
                                            <option value={DeliverOption.DROP_AT_DOOR} className="place-order-title">
                                              Drop at door
                                            </option>
                                            <option value={DeliverOption.DROP_AT_MAILBOX}>Drop at mailbox</option>
                                            <option value={DeliverOption.DROP_AT_FRONT_DESK}>Drop at front desk</option>
                                            <option value={DeliverOption.RETURN_ON_FAILED}>Return the package to me</option>
                                            <option value={DeliverOption.REATTEMPT_ON_FAILED}>Reattempt for tomorrow</option>
                                            <option value={DeliverOption.CALL_ME_TO_CONFIRM}>Call me to confirm</option>
                                            <option value={DeliverOption.DELIVERY_VERIFICATION_PIN} onMouseDown={() => handleMouseDown(DeliverOption.DELIVERY_VERIFICATION_PIN)}    >Delivery Verification Pin</option>
                                            <option value={DeliverOption.SIGNATURE_REQUIRED}>Signature Required</option>

                                          </>)}
                                      </Select>
                                      <DeliveryVerificationModal showModal={showModal} handleClosePinModal={handleClosePinModal} setDeliveryPin={setDeliveryPin}
                                      />
                                    </div>
                                    {errors.deliveryOption && touched.deliveryOption && (
                                      <p className="error place-order-title">{errors.deliveryOption}</p>
                                    )}
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label for="basicpill-companyuin-input9" className="place-order-title">
                                        Notes<Label className="title-star"></Label>
                                      </Label>
                                      <input
                                        value={values.description}
                                        onChange={handleChange}
                                        id="description"
                                        type="text"
                                        placeholder=""
                                        onBlur={handleBlur}
                                        className="form-control"
                                      />
                                    </div>
                                  </Col>
                                  <Col lg="6" md="12">
                                    <div className="mb-3 form-group">
                                      <Label for="basicpill-companyuin-input9" className="place-order-title">
                                        Sent by<Label className="title-star"></Label>
                                      </Label>
                                      <input
                                        value={values.sentBy}
                                        onChange={handleChange}
                                        id="sentBy"
                                        type="text"
                                        placeholder=""
                                        onBlur={handleBlur}
                                        className="form-control"
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Form>
                            </div>
                          </TabPane>

                          <TabPane tabId={3}>
                            <div className="row justify-content-center">
                              <Col lg="6" md="12">
                                <div className="text-center">
                                  <div className="mb-4">
                                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                                  </div>
                                  <div>
                                    <h5>Confirm Detail</h5>
                                    <p className="text-muted">Successfully Place Your Order</p>
                                  </div>
                                </div>
                              </Col>
                            </div>
                            <div className="row justify-content-center m-lg-5">
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3 form-group">
                                    <Label for="basicpill-companyuin-input9" className="place-order-title text-primary fw-bold">
                                      Pick-Up Details
                                    </Label>
                                    <div>
                                      <Row>
                                        <Col lg="5" md="5" sm="4" xs="4">
                                          <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                            Pickup address
                                          </Label>
                                        </Col>
                                        <Col>
                                          <Label> : </Label>
                                        </Col>
                                        <Col lg="5" md="6" sm="6" xs="6">
                                          <Label for="basicpill-companyuin-input9" className="text-muted">
                                            {picup?.city}<br />
                                            {picup?.postalCode}
                                          </Label>
                                        </Col>
                                      </Row>
                                    </div>
                                    <div>
                                      <Row>
                                        <Col lg="5" md="5" sm="4" xs="4">
                                          <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                            Company Name
                                          </Label>
                                        </Col>
                                        <Col>
                                          <Label> : </Label>
                                        </Col>
                                        <Col lg="5" md="6" sm="6" xs="6">
                                          <Label for="basicpill-companyuin-input9" className="text-muted">
                                            {values?.companyName}
                                          </Label>
                                        </Col>
                                      </Row>
                                    </div>
                                    <div>
                                      <Row>
                                        <Col lg="5" md="5" sm="4" xs="4">
                                          <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                            Contact Name
                                          </Label>
                                        </Col>
                                        <Col>
                                          <Label> : </Label>
                                        </Col>
                                        <Col lg="5" md="6" sm="6" xs="6">
                                          <Label for="basicpill-companyuin-input9" className="text-muted">
                                            {values?.pickupContactName}
                                          </Label>
                                        </Col>
                                      </Row>
                                    </div>
                                    <div>
                                      <Row>
                                        <Col lg="5" md="5" sm="4" xs="4">
                                          <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                            Contact Phone
                                          </Label>
                                        </Col>
                                        <Col>
                                          <Label> : </Label>
                                        </Col>
                                        <Col lg="5" md="6" sm="6" xs="6">
                                          <Label for="basicpill-companyuin-input9" className="text-muted">
                                            {values?.pickupContactPhone}
                                          </Label>
                                        </Col>
                                      </Row>
                                    </div>
                                    <div>
                                      <Row>
                                        <Col lg="5" md="5" sm="4" xs="4">
                                          <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                            Unit Number
                                          </Label>
                                        </Col>
                                        <Col>
                                          <Label> : </Label>
                                        </Col>
                                        <Col lg="5" md="6" sm="6" xs="6">
                                          <Label for="basicpill-companyuin-input9" className="text-muted">
                                            {values?.pickupUnit}
                                          </Label>
                                        </Col>
                                      </Row>
                                    </div>
                                    <div>
                                      <Row>
                                        <Col lg="5" md="5" sm="4" xs="4">
                                          <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                            Pick - Up date and Time
                                          </Label>
                                        </Col>
                                        <Col>
                                          <Label> : </Label>
                                        </Col>
                                        <Col lg="5" md="6" sm="6" xs="6">
                                          <Label for="basicpill-companyuin-input9" className="text-muted">
                                            {pickupDateTime?.format("YYYY-MM-DD HH:mm")}
                                          </Label>
                                        </Col>
                                      </Row>
                                    </div>
                                    <div>
                                      <Row>
                                        <Col lg="5" md="5" sm="4" xs="4">
                                          <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                            Notes
                                          </Label>
                                        </Col>
                                        <Col>
                                          <Label> : </Label>
                                        </Col>
                                        <Col lg="5" md="6" sm="6" xs="6">
                                          <Label for="basicpill-companyuin-input9" className="text-muted">
                                            <TextWithLineBreaks text={values?.note} />
                                            {/* {values?.note.length > 35 ? values?.note.slice(0, 35) : values?.note} */}
                                          </Label>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                                <Col lg="6">
                                  <div className="mb-3 form-group">
                                    <Label for="basicpill-companyuin-input9" className="place-order-title text-primary fw-bold">
                                      Delivery Details
                                    </Label>
                                    <Row>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Delivery address
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {deliver?.city}<br />
                                              {deliver?.postalCode}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Company Name
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {values?.deliverCompany}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Contact Name
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {values?.deliverContactName}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Contact Phone
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {values?.deliverContactPhone}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Total Number of Items
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {values?.totalItems}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Total Weight of all Items
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {values?.totalWeight}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Unit Number
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {values?.deliverUnit}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Choose Vehicle
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {values?.vehicleType}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Notes
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              <TextWithLineBreaks text={values?.description} />
                                              {/* {values?.description.length > 35 ? values?.description.slice(0, 35) : values?.description} */}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Sent By
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {values?.sentBy}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Service time
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {pickupDateTime.format("hh:mma") +
                                                " to " +
                                                deliveryDateTime.format("hh:mma")}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Row>
                                  </div>
                                </Col>
                                <Col lg="6">
                                  <div className="mb-3 form-group">
                                    <Label for="basicpill-companyuin-input9" className="place-order-title text-primary fw-bold">
                                      Quote Details
                                    </Label>
                                    <Row>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Total distance
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {orderDetailsRespose?.totalDistance}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      <div>
                                        <Row>
                                          <Col lg="5" md="5" sm="4" xs="4">
                                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                              Subtotal
                                            </Label>
                                          </Col>
                                          <Col>
                                            <Label> : </Label>
                                          </Col>
                                          <Col lg="5" md="6" sm="6" xs="6">
                                            <Label for="basicpill-companyuin-input9" className="text-muted">
                                              {"$" + orderDetailsRespose?.subTotal?.toString()}
                                            </Label>
                                          </Col>
                                        </Row>
                                      </div>
                                      {user?.paymentOption == PaymentOption.SINGLE ? (
                                        <>
                                          <div>
                                            <Row>
                                              <Col lg="5" md="5" sm="4" xs="4">
                                                <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                                  HST 13%
                                                </Label>
                                              </Col>
                                              <Col>
                                                <Label> : </Label>
                                              </Col>
                                              <Col lg="5" md="6" sm="6" xs="6">
                                                <Label for="basicpill-companyuin-input9" className="text-muted">
                                                  {"$" + orderDetailsRespose?.hst?.toString()}
                                                </Label>
                                              </Col>
                                            </Row>
                                          </div>
                                          <div>
                                            <Row>
                                              <Col lg="5" md="5" sm="4" xs="4">
                                                <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                                  Total Fare
                                                </Label>
                                              </Col>
                                              <Col>
                                                <Label> : </Label>
                                              </Col>
                                              <Col lg="5" md="6" sm="6" xs="6">
                                                <Label for="basicpill-companyuin-input9" className="text-muted">
                                                  {"$" + orderDetailsRespose?.totalFare?.toFixed(2)}
                                                </Label>
                                              </Col>
                                            </Row>
                                          </div>
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </Row>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </TabPane>
                          <TabPane tabId={4}>
                            <div>
                              <div className="table-responsive react-table">
                                <table className="newTable">
                                  <thead className="newThead">
                                    <tr>
                                      <th scope="col">S.No</th>
                                      <th scope="col">Pick-up</th>
                                      <th scope="col">Delivery</th>
                                      <th scope="col">Distance</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td scope="row" data-label="S.No">1</td>
                                      <td data-label="Pick-up">{orderRespose?.pickUpAddress?.city}</td>
                                      <td data-label="Delivery">{orderRespose?.deliveryAddress?.city}</td>
                                      <td data-label="Distance">{orderRespose?.totalDistance}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <line></line>

                              <Row className="row g-5 justify-content-center">
                                <Col lg="3">
                                  <table className="table">
                                    <tbody className="place-order-title">
                                      <tr>
                                        <td>Total distance:</td>
                                        <td>{orderRespose?.totalDistance}</td>
                                      </tr>
                                      <tr>
                                        <td>Subtotal:</td>
                                        {/* <td>$ {orderRespose?.subTotal?.toFixed(2)}</td> */}
                                        <td>
                                          $ {user?.paymentOption == PaymentOption.SINGLE
                                            ? finalOrder?.subTotal?.toFixed(2)
                                            : orderRespose?.subTotal?.toFixed(2)}
                                        </td>
                                      </tr>
                                    </tbody>

                                    {user?.paymentOption == PaymentOption.SINGLE ? (
                                      <>
                                        <tbody className="place-order-title">
                                          {promosEnabled && (
                                            <tr>
                                              <td colSpan={2} className="!p-0">
                                                <div
                                                  onClick={() => setIsModalOpen(true)}
                                                  className="flex items-center rounded-full px-4 py-2 w-full cursor-pointer bg-primary text-white hover:shadow transition-all gap-2"
                                                >
                                                  <TagsIcon className="text-xl ml-3" />
                                                  <span>
                                                    {promoCode ? promoCode : ' Enter Promo Code'}
                                                  </span>
                                                </div>
                                              </td>
                                            </tr>
                                          )}

                                          <tr>
                                            <td>HST 13%:</td>
                                            <td>$ {finalOrder?.hst?.toFixed(2)}</td>
                                          </tr>
                                          <tr>
                                            <td>Total Fare:</td>
                                            <td>$ {finalOrder?.totalFare?.toFixed(2)}</td>
                                          </tr>
                                        </tbody>
                                        {promosEnabled && (
                                          <Modal isOpen={isModalOpen} toggle={() => {
                                            setIsModalOpen(false);
                                            setPromoError('');
                                          }} className="rounded-xl">
                                            <ModalHeader toggle={() => {
                                              setIsModalOpen(false);
                                              setPromoError('');
                                            }} className="border-b-0 pb-0">
                                              Enter Promo Code
                                            </ModalHeader>
                                            <ModalBody>
                                              <div className="mb-3">
                                                <input
                                                  type="text"
                                                  className={`w-full border ${promoError ? 'border-danger' : 'border-gray-300'} rounded-md p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none`}
                                                  value={promoInput}
                                                  onChange={(e) => {
                                                    setPromoInput(e.target.value);
                                                    setPromoError('');
                                                  }}
                                                  autoFocus
                                                />
                                                {promoError && (
                                                  <div className="text-danger mt-1 text-sm">{promoError}</div>
                                                )}
                                              </div>

                                              {/* {appliedPromo && (
                                              <div className="bg-green-50 text-green-700 p-3 rounded-md mb-3">
                                                <div className="font-medium">Active Discount:</div>
                                                <div>{appliedPromo.code} - {appliedPromo.discountPercent}% off</div>
                                              </div>
                                            )} */}
                                            </ModalBody>
                                            <ModalFooter className="border-t-0 pt-0">
                                              <Button
                                                onClick={() => {
                                                  setIsModalOpen(false);
                                                  setPromoError('');
                                                }}
                                                color="secondary"
                                              >
                                                Cancel
                                              </Button>
                                              <Button
                                                onClick={handleApplyPromo}
                                                color="primary"
                                                disabled={!promoInput.trim() || !!appliedPromo}
                                              >
                                                {appliedPromo ? "Applied" : "Apply Code"}
                                              </Button>
                                            </ModalFooter>
                                          </Modal>
                                        )}

                                      </>
                                    ) : (
                                      <div></div>
                                    )}
                                  </table>
                                </Col>
                              </Row>
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>

                      <div className="actions clearfix">
                        <ul>
                          {activeTab === 1 || activeTab === 2 || activeTab === 3 ? (
                            <li className={activeTab === 1 ? "previous disabled" : "previous"}>
                              <button
                                type="button"
                                onClick={() => {
                                  toggleTab(activeTab - 1);
                                }}
                                className="btn btn-sm btn-primary"
                              >
                                Previous
                              </button>
                            </li>
                          ) : user?.paymentOption == PaymentOption.SINGLE ? (
                            <li className="previous">
                              <button type="button" onClick={deleteOrder} className="btn btn-sm btn-primary">
                                Cancel
                              </button>
                            </li>
                          ) : (
                            <li></li>
                          )}
                          {activeTab === 3 ? (
                            <button
                              type="submit"
                              className="btn btn-sm btn-primary "
                              onClick={() => {
                                checkPickUpTime();
                                statuscount();
                              }}
                              disabled={isSubmittingOrder}
                            >
                              {isSubmittingOrder ? "Submitting..." : "Next"} <i className="icon-4"></i>
                            </button>
                          ) : activeTab === 4 ? (
                            user?.paymentOption == PaymentOption.MONTHLY ? (
                              <li className={"next"}>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-primary "
                                  onClick={() => {
                                    setactiveTab(1);
                                    setUserData(!userData);
                                    statuscount();
                                    setDeliveryPin("");
                                  }}
                                >
                                  Go back <i className="icon-4"></i>
                                </button>{" "}
                              </li>
                            ) : (
                              <li className={"next"}>
                                <button type="button" className="btn btn-sm btn-primary" onClick={() => { checkPickUpTime(); handlePayment(); }}>
                                  Pay Now <i className="icon-4"></i>
                                </button>{" "}
                              </li>
                            )
                          ) : (
                            <li className={"next"}>
                              <button
                                onClick={() => {
                                  if (activeTab == 1) {
                                    toggleTab1(2);
                                  } else if (activeTab == 2) {
                                    handleDeliveryDateChange(torontoMomentToDatePickerDate(deliveryDateTime));
                                    toggleTab2(3);
                                  }
                                  checkPickUpTime();
                                }}
                                type="button"
                                className="btn btn-sm btn-primary"
                              >
                                Next
                              </button>
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    </form >
  );
};

export default PlaceOrdersBusiness;
